export default {
	TEST_ALERT: 'test-alert',
	STUDENT_UI_POLL_QUIZ_OEQ: 'student-ui-poll-quiz-oeq',
	TIMER_DRAW_IT: 'timer-draw-it',
	TIMER_MATCHING_PAIRS: 'timer-matching-pairs',
	STUDENT_RECORDING_AUDIO_OEQ: 'student-recording-audio-oeq',
	STORE_NEW_ROUTES: 'store-new-routes',
	PREVIEW_LESSON_SHOW_IN_MY_LIBRARY: 'preview-lesson-show-in-my-library',
	FLOCABULARY_CREATION: 'flocabulary-creation',
	TIME_TO_CLIMB_IMAGE_ANSWERS_LOCAL_FILES: 'time-to-climb-image-answers-local-files',
	FLOCABULARY_V2_IMPROVEMENTS: 'flocabulary-v2-improvements',
	MY_ACTIVITIES: 'my-activities',
	MAIN_TOPBAR_TOOLTIPS: 'main-topbar-tooltips',
	VIDEO_LESSON_TYPE: 'video-lesson-type',
	VIDEO_LESSON_SHOW_TEACH_BUTTON: 'video-lesson-show-teach-button',
	QUICK_LAUNCH_COLLABORATE: 'quick-launch-collaborate',
	QUICK_LAUNCH_DRAWIT: 'quick-launch-drawit',
	QUICK_LAUNCH_FIELDTRIP: 'quick-launch-fieldtrip',
	QUICK_LAUNCH_OEQ: 'quick-launch-oeq',
	QUICK_LAUNCH_TIMER: 'quick-launch-timer',
	OEQ_AUDIO_RESPONSES: 'oeq-audio-responses',
	FLIPGRID: 'flipgrid',
	CSE_IMAGE_SEARCH: 'cse-image-search',
	MICROSOFT_TEAMS_LIVE_LESSON: 'microsoft-teams-live-lesson',
	TEACHER_DASHBOARD_SELF_PACED: 'teacher-dashboard-self-paced',
	INTERACTIVE_VIDEO_MCQ: 'interactive-video-mcq',
	INTERACTIVE_VIDEO_AUTOSUBMIT: 'interactive-video-autosubmit',
	INTERACTIVE_VIDEO_PREVENT_SKIPPING_VIDEOS: 'interactive-video-prevent-skipping-videos',
	INTERACTIVE_VIDEO_YOUTUBE_SEARCH: 'interactive-video-youtube-search',
	UNPUBLISH_VIDEO_LESSONS_EDIT_OEQ_AND_MCQ: 'unpublish-video-lessons-edit-oeq-mcq',
	NOTIFICATION_PREFERENCES: 'notification-preferences',
	READ_ONLY_IMMERSIVE_READER: 'read-only-immersive-reader',
	GOOGLE_SLIDES_CLICKABLE_LINKS: 'google-slides-clickable-links',
	INTERACTIVE_VIDEO_TEACHER_MCQ_DASHBOARD_LIVE: 'interactive-video-teacher-mcq-live-dashboard',
	VIDEO_LESSON_STREAMLINE: 'video-lesson-streamline',
	MY_VIDEOS_PICKER_TAB: 'my-videos-picker-tab',
	PAYWALLS_PROJECT: 'paywalls-project',
	STUDENT_LIBRARY: 'student-library',
	NAV_TOPBAR: 'nav-topbar',
	MY_LIBRARY_MOVE_LESSONS_TO_SCHOOL_OR_DISTRICT_LIBRARY: 'my-library-move-lessons-to-school-or-district-library',
	IMMERSIVE_READER_VIDEO: 'immersive-reader-video',
	INTERACTIVE_VIDEO_GOOGLE_SLIDES: 'interactive-video-google-slides',
	TEACH_BUTTON_AND_MODAL: 'teach-button-and-modal',
	USER_SCHOOL_PROFILE_ONLY_ROLE: 'user-school-profile-only-role',
	IOS_IMMERSIVE_READER: 'ios-immersive-reader',
	INTERACTIVE_VIDEO_PREVIEW_CREDITS_TAB: 'interactive-video-preview-credits-tab',
	INTERACTIVE_VIDEO_PREVIEW_STANDARDS_TAB: 'interactive-video-preview-standards-tab',
	INTERACTIVE_VIDEO_WELCOME_MODAL: 'interactive-video-welcome-modal',
	INTERACTIVE_VIDEO_TRIMMING: 'interactive-video-trimming',
	INTERACTIVE_VIDEO_EDITOR_WELCOME_TOUR: 'interactive-video-editor-welcome-tour',
	VIDEO_PLAYER_ALTERNATIVE_HANDLER: 'video-player-alternative-handler',
	VIDEO_PREVIEW_BANNER: 'video-preview-banner',
	INTERACTIVE_VIDEO_CONVERT_TO_SLIDES: 'interactive-video-convert-to-slides',
	INTERACTIVE_VIDEO_YOUTUBE_CAPTIONS: 'interactive-video-youtube-captions',
	INTERACTIVE_VIDEO_LIVE_STUDENT_PACED_MODE: 'live-student-paced-mode',
	SPEEDS_PICKER_IN_VIDEO: 'speeds-picker-in-video',
	CREATE_MENU: 'create-menu',
	AUDIO_RECORDER_OEQ: 'audio-recorder-oeq',
	AUDIO_RECORDER_DRAWIT: 'audio-recorder-drawit',
	EXPLORE_LIBRARY_THUMBNAIL: 'explore-library-thumbnail',
	MCQ_MULTIPLE_CORRECT_ANSWERS: 'mcq-multiple-correct-answers',
	RICH_TEXT_OEQ: 'rich-text-oeq',
	RICH_TEXT_STUDENT_SESSION: 'rich-text-student-session',
	GOOGLE_SLIDES_SILVER_PAYWALL: 'google-slides-silver-paywall',
	CREATE_LESSON_THUMBNAIL: 'create-lesson-thumbnail',
	ONBOARDING_GUIDE: 'onboarding-guide',
	RICH_TEXT_MATH_FORMULAS_PLUGIN: 'rich-text-math-formulas-plugin',
	SEND_FEEDBACK_REDIRECT_TO_CANNY: 'send-feedback-redirect-to-canny',
	RICH_TEXT_QUIZ: 'rich-text-quiz',
	ACTIVITY_BANKS: 'activity-banks',
	RICH_TEXT_POLL: 'rich-text-poll',
}
